import {useState} from "react";

function UpdateLanguages() {
  const [updateLis, setUpdateLis] = useState<boolean>(false);

  return { updateLis, setUpdateLis };
}

export default UpdateLanguages;
